import { CSSProperties } from "react"
import Constants from "../../../../constants"

const tableHeaderStyle: CSSProperties = {
    textAlign: "left",
    /*
        Aqui habia un minWidth de 150px. Con diez columnas eso son 1 500px de
        minimo: en cualquier portatil salia barra horizontal y no habia forma de
        encoger la tabla, ni siquiera para un Id de seis cifras. Cada columna ya
        declara el ancho que necesita. (Esteban, 2026-09-16)
    */
    color: "var(--wa-tinta)",
    borderBottom: "1px solid black",
    font: Constants.Styles.text.fonts.robotoBold14
}

export const styles = {
    tableHeaderStyle
}